/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v1
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateUser } from '../model';
// @ts-ignore
import type { EnableDisableSchema } from '../model';
// @ts-ignore
import type { ErrorResponse } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { OrganizationRoles } from '../model';
// @ts-ignore
import type { OrganizationUser } from '../model';
// @ts-ignore
import type { PageOrganizationWithFrameworkCodes } from '../model';
// @ts-ignore
import type { Tags } from '../model';
// @ts-ignore
import type { UserOrgPage } from '../model';
/**
 * OrganizationsApi - axios parameter creator
 */
export const OrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete Organizations User Roles
         * @param {string} userId 
         * @param {string} organizationId 
         * @param {OrganizationRoles} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDelete: async (userId: string, organizationId: string, role: OrganizationRoles, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDelete', 'userId', userId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDelete', 'organizationId', organizationId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('deleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDelete', 'role', role)
            const localVarPath = `/organizations/{organization_id}/users/{user_id}/roles`
                .replace('{user_id}', encodeURIComponent(String(userId)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable Disable Platform Framework For Organizations
         * @param {string} organizationId 
         * @param {EnableDisableSchema} enableDisableSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPost: async (organizationId: string, enableDisableSchema: EnableDisableSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('enableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPost', 'organizationId', organizationId)
            // verify required parameter 'enableDisableSchema' is not null or undefined
            assertParamExists('enableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPost', 'enableDisableSchema', enableDisableSchema)
            const localVarPath = `/organizations/{organization_id}/platform-frameworks`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enableDisableSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all organizations.  Args:     db (Session): The database session.  Returns:     Page[schemas.Organization]: The organizations.
         * @summary Get Organizations
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsOrganizationsGet: async (name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Platform Tags
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformTagsV1OrganizationsOrganizationIdTagsGet: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPlatformTagsV1OrganizationsOrganizationIdTagsGet', 'organizationId', organizationId)
            const localVarPath = `/v1/organizations/{organization_id}/tags`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Users Of Organization
         * @param {string} organizationId 
         * @param {string | null} [name] The user name filter.
         * @param {string | null} [notInProject] Filter by users not in a project.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {boolean} [includeInactive] Filter by status. By default, inactive users will not be returned.
         * @param {string | null} [state] Filter by user current state.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersOfOrganizationOrganizationsOrganizationIdUsersGet: async (organizationId: string, name?: string | null, notInProject?: string | null, sortBy?: string | null, descending?: boolean, includeInactive?: boolean, state?: string | null, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getUsersOfOrganizationOrganizationsOrganizationIdUsersGet', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organization_id}/users`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (notInProject !== undefined) {
                localVarQueryParameter['not_in_project'] = notInProject;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (includeInactive !== undefined) {
                localVarQueryParameter['include_inactive'] = includeInactive;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Organizations User Roles
         * @param {string} userId 
         * @param {string} organizationId 
         * @param {OrganizationRoles} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPost: async (userId: string, organizationId: string, role: OrganizationRoles, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('postOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPost', 'userId', userId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPost', 'organizationId', organizationId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('postOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPost', 'role', role)
            const localVarPath = `/organizations/{organization_id}/users/{user_id}/roles`
                .replace('{user_id}', encodeURIComponent(String(userId)))
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post User Force
         * @param {string} organizationId 
         * @param {CreateUser} createUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserForceOrganizationsOrganizationIdUsersForcePost: async (organizationId: string, createUser: CreateUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postUserForceOrganizationsOrganizationIdUsersForcePost', 'organizationId', organizationId)
            // verify required parameter 'createUser' is not null or undefined
            assertParamExists('postUserForceOrganizationsOrganizationIdUsersForcePost', 'createUser', createUser)
            const localVarPath = `/organizations/{organization_id}/users_force`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationsApi - functional programming interface
 */
export const OrganizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete Organizations User Roles
         * @param {string} userId 
         * @param {string} organizationId 
         * @param {OrganizationRoles} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDelete(userId: string, organizationId: string, role: OrganizationRoles, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDelete(userId, organizationId, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.deleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Enable Disable Platform Framework For Organizations
         * @param {string} organizationId 
         * @param {EnableDisableSchema} enableDisableSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPost(organizationId: string, enableDisableSchema: EnableDisableSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPost(organizationId, enableDisableSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.enableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all organizations.  Args:     db (Session): The database session.  Returns:     Page[schemas.Organization]: The organizations.
         * @summary Get Organizations
         * @param {string | null} [name] The name filter.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsOrganizationsGet(name?: string | null, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageOrganizationWithFrameworkCodes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsOrganizationsGet(name, sortBy, descending, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationsOrganizationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Platform Tags
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformTagsV1OrganizationsOrganizationIdTagsGet(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tags>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformTagsV1OrganizationsOrganizationIdTagsGet(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getPlatformTagsV1OrganizationsOrganizationIdTagsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Users Of Organization
         * @param {string} organizationId 
         * @param {string | null} [name] The user name filter.
         * @param {string | null} [notInProject] Filter by users not in a project.
         * @param {string | null} [sortBy] Sort by a field.
         * @param {boolean} [descending] Sort order. If true, descending, otherwise ascending.
         * @param {boolean} [includeInactive] Filter by status. By default, inactive users will not be returned.
         * @param {string | null} [state] Filter by user current state.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersOfOrganizationOrganizationsOrganizationIdUsersGet(organizationId: string, name?: string | null, notInProject?: string | null, sortBy?: string | null, descending?: boolean, includeInactive?: boolean, state?: string | null, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOrgPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersOfOrganizationOrganizationsOrganizationIdUsersGet(organizationId, name, notInProject, sortBy, descending, includeInactive, state, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getUsersOfOrganizationOrganizationsOrganizationIdUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post Organizations User Roles
         * @param {string} userId 
         * @param {string} organizationId 
         * @param {OrganizationRoles} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPost(userId: string, organizationId: string, role: OrganizationRoles, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPost(userId, organizationId, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.postOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post User Force
         * @param {string} organizationId 
         * @param {CreateUser} createUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserForceOrganizationsOrganizationIdUsersForcePost(organizationId: string, createUser: CreateUser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserForceOrganizationsOrganizationIdUsersForcePost(organizationId, createUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.postUserForceOrganizationsOrganizationIdUsersForcePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationsApi - factory interface
 */
export const OrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete Organizations User Roles
         * @param {OrganizationsApiDeleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDelete(requestParameters: OrganizationsApiDeleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDelete(requestParameters.userId, requestParameters.organizationId, requestParameters.role, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable Disable Platform Framework For Organizations
         * @param {OrganizationsApiEnableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPost(requestParameters: OrganizationsApiEnableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPost(requestParameters.organizationId, requestParameters.enableDisableSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all organizations.  Args:     db (Session): The database session.  Returns:     Page[schemas.Organization]: The organizations.
         * @summary Get Organizations
         * @param {OrganizationsApiGetOrganizationsOrganizationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsOrganizationsGet(requestParameters: OrganizationsApiGetOrganizationsOrganizationsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageOrganizationWithFrameworkCodes> {
            return localVarFp.getOrganizationsOrganizationsGet(requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Platform Tags
         * @param {OrganizationsApiGetPlatformTagsV1OrganizationsOrganizationIdTagsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformTagsV1OrganizationsOrganizationIdTagsGet(requestParameters: OrganizationsApiGetPlatformTagsV1OrganizationsOrganizationIdTagsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Tags> {
            return localVarFp.getPlatformTagsV1OrganizationsOrganizationIdTagsGet(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Users Of Organization
         * @param {OrganizationsApiGetUsersOfOrganizationOrganizationsOrganizationIdUsersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersOfOrganizationOrganizationsOrganizationIdUsersGet(requestParameters: OrganizationsApiGetUsersOfOrganizationOrganizationsOrganizationIdUsersGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserOrgPage> {
            return localVarFp.getUsersOfOrganizationOrganizationsOrganizationIdUsersGet(requestParameters.organizationId, requestParameters.name, requestParameters.notInProject, requestParameters.sortBy, requestParameters.descending, requestParameters.includeInactive, requestParameters.state, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Organizations User Roles
         * @param {OrganizationsApiPostOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPost(requestParameters: OrganizationsApiPostOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPost(requestParameters.userId, requestParameters.organizationId, requestParameters.role, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post User Force
         * @param {OrganizationsApiPostUserForceOrganizationsOrganizationIdUsersForcePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserForceOrganizationsOrganizationIdUsersForcePost(requestParameters: OrganizationsApiPostUserForceOrganizationsOrganizationIdUsersForcePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationUser> {
            return localVarFp.postUserForceOrganizationsOrganizationIdUsersForcePost(requestParameters.organizationId, requestParameters.createUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDelete operation in OrganizationsApi.
 */
export interface OrganizationsApiDeleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDeleteRequest {
    readonly userId: string

    readonly organizationId: string

    readonly role: OrganizationRoles
}

/**
 * Request parameters for enableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPost operation in OrganizationsApi.
 */
export interface OrganizationsApiEnableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPostRequest {
    readonly organizationId: string

    readonly enableDisableSchema: EnableDisableSchema
}

/**
 * Request parameters for getOrganizationsOrganizationsGet operation in OrganizationsApi.
 */
export interface OrganizationsApiGetOrganizationsOrganizationsGetRequest {
    /**
     * The name filter.
     */
    readonly name?: string | null

    /**
     * Sort by a field.
     */
    readonly sortBy?: string | null

    /**
     * Sort order. If true, descending, otherwise ascending.
     */
    readonly descending?: boolean

    readonly page?: number

    readonly size?: number
}

/**
 * Request parameters for getPlatformTagsV1OrganizationsOrganizationIdTagsGet operation in OrganizationsApi.
 */
export interface OrganizationsApiGetPlatformTagsV1OrganizationsOrganizationIdTagsGetRequest {
    readonly organizationId: string
}

/**
 * Request parameters for getUsersOfOrganizationOrganizationsOrganizationIdUsersGet operation in OrganizationsApi.
 */
export interface OrganizationsApiGetUsersOfOrganizationOrganizationsOrganizationIdUsersGetRequest {
    readonly organizationId: string

    /**
     * The user name filter.
     */
    readonly name?: string | null

    /**
     * Filter by users not in a project.
     */
    readonly notInProject?: string | null

    /**
     * Sort by a field.
     */
    readonly sortBy?: string | null

    /**
     * Sort order. If true, descending, otherwise ascending.
     */
    readonly descending?: boolean

    /**
     * Filter by status. By default, inactive users will not be returned.
     */
    readonly includeInactive?: boolean

    /**
     * Filter by user current state.
     */
    readonly state?: string | null

    readonly page?: number

    readonly size?: number
}

/**
 * Request parameters for postOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPost operation in OrganizationsApi.
 */
export interface OrganizationsApiPostOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPostRequest {
    readonly userId: string

    readonly organizationId: string

    readonly role: OrganizationRoles
}

/**
 * Request parameters for postUserForceOrganizationsOrganizationIdUsersForcePost operation in OrganizationsApi.
 */
export interface OrganizationsApiPostUserForceOrganizationsOrganizationIdUsersForcePostRequest {
    readonly organizationId: string

    readonly createUser: CreateUser
}

/**
 * OrganizationsApi - object-oriented interface
 */
export class OrganizationsApi extends BaseAPI {
    /**
     * 
     * @summary Delete Organizations User Roles
     * @param {OrganizationsApiDeleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDelete(requestParameters: OrganizationsApiDeleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDeleteRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).deleteOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesDelete(requestParameters.userId, requestParameters.organizationId, requestParameters.role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable Disable Platform Framework For Organizations
     * @param {OrganizationsApiEnableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public enableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPost(requestParameters: OrganizationsApiEnableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPostRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).enableDisablePlatformFrameworkForOrganizationsOrganizationsOrganizationIdPlatformFrameworksPost(requestParameters.organizationId, requestParameters.enableDisableSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all organizations.  Args:     db (Session): The database session.  Returns:     Page[schemas.Organization]: The organizations.
     * @summary Get Organizations
     * @param {OrganizationsApiGetOrganizationsOrganizationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationsOrganizationsGet(requestParameters: OrganizationsApiGetOrganizationsOrganizationsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationsOrganizationsGet(requestParameters.name, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Platform Tags
     * @param {OrganizationsApiGetPlatformTagsV1OrganizationsOrganizationIdTagsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlatformTagsV1OrganizationsOrganizationIdTagsGet(requestParameters: OrganizationsApiGetPlatformTagsV1OrganizationsOrganizationIdTagsGetRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getPlatformTagsV1OrganizationsOrganizationIdTagsGet(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Users Of Organization
     * @param {OrganizationsApiGetUsersOfOrganizationOrganizationsOrganizationIdUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsersOfOrganizationOrganizationsOrganizationIdUsersGet(requestParameters: OrganizationsApiGetUsersOfOrganizationOrganizationsOrganizationIdUsersGetRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getUsersOfOrganizationOrganizationsOrganizationIdUsersGet(requestParameters.organizationId, requestParameters.name, requestParameters.notInProject, requestParameters.sortBy, requestParameters.descending, requestParameters.includeInactive, requestParameters.state, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Organizations User Roles
     * @param {OrganizationsApiPostOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPost(requestParameters: OrganizationsApiPostOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPostRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).postOrganizationsUserRolesOrganizationsOrganizationIdUsersUserIdRolesPost(requestParameters.userId, requestParameters.organizationId, requestParameters.role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post User Force
     * @param {OrganizationsApiPostUserForceOrganizationsOrganizationIdUsersForcePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postUserForceOrganizationsOrganizationIdUsersForcePost(requestParameters: OrganizationsApiPostUserForceOrganizationsOrganizationIdUsersForcePostRequest, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).postUserForceOrganizationsOrganizationIdUsersForcePost(requestParameters.organizationId, requestParameters.createUser, options).then((request) => request(this.axios, this.basePath));
    }
}

